<template>
  <div class="landing-home-page">
    <AppHero />
    <HomeAbout />
  </div>
</template>

<script>
import AppHero from '../components/AppHero.vue';
import HomeAbout from '../components/HomeAbout.vue';

export default {
  name: 'HomeView',
  components: {
    AppHero,
    HomeAbout
  }
};
</script>
